export const getTermsURL = () => (
  'https://indemandly-assets.s3-us-west-2.amazonaws.com/terms.html'
)
